import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: "/app-supply",
  children: [
    {
      path: "app-download",
      name: "supply-app-download",
      component: () => import('@/views/app-supply/index.vue'),
      meta: {
        title: "佬司机",
      },
    },
    {
      path: "wechat-payment",
      name: "wechat-payment",
      component: () => import('@/views/app-supply/wechat-payment/index.vue'),
      meta: {
        title: "好友代付",
      },
    },
    {
      path: "pre-upgrade/:versionId",
      name: "supply-app-pre-upgrade",
      component: () => import('@/views/app-supply/pre-upgrade/index.vue'),
      props: true,
      meta: {
        title: "佬司机预更新介绍",
      },
    },
    {
      path: "/app-supply/:path(.*)*",
      redirect: "/app-driver/app-download"
    }
  ],
};

export default routes;
